import React from 'react';
import { Container, Col, Modal, ModalBody, Row } from 'react-bootstrap';
import ModalHeader from '../ModalHeader';
import Label from '../Label';
import Image from 'react-bootstrap/Image';
import Button from '../Button';
import {getAllCases} from '../../services/cases';

export type commentModalProps = React.PropsWithoutRef<{
  showModal: boolean;
  caseId: any;
  handleClose: () => void;
}>;



const CommentModal = ({
  showModal = false,
  caseId,
  handleClose,
  ...props
}: commentModalProps) => {
  const caseList = getAllCases();

  // Filter the caseList to match the specified caseId
  const filteredCase = caseList.filter(caseItem => caseItem.id === caseId);
  const matchedCase = filteredCase.length > 0 ? filteredCase[0] : null;

  return (
    <Modal show={showModal} onHide={handleClose} {...props} size="xl">
      <ModalHeader closeButton>
        <h5>Historical Comment</h5>
      </ModalHeader>
      <ModalBody className="pt-9">
        
        <section>
        <Container className={'px-0 py-0'}>
        {matchedCase && (
          <>
          <Row className={'mt-0 py-5 border-top-light-gray-2px'}>
              <Col className={'col-3'}>
                <div className={'align-items-center'}>{matchedCase.commentDate}</div>
              </Col>
              <Col className={'col-3'}>
                <div className={'align-items-center'}>{matchedCase.commentTime}</div>
              </Col>
              <Col className={'col-3'}>
                <div className={'align-items-center'}>{matchedCase.commentCode}</div>
              </Col>
              <Col className={'col-3'}>
                <div className={'align-items-center'}>{matchedCase.inbox}</div>
              </Col>
          </Row>
          <Row className={'my-5 pb-10 border-bottom-light-gray-lg text-fs-6 fw-light lh-xs'}>
            <Col className={'col-12'}>
                <span className={'text-dark-gray-50'}>{matchedCase.commentNote}</span>
            </Col>
          </Row>
          
          </>
          )}
          <Row className={'justify-content-center'}>
            <Col className={'col-12 col-lg-4 mt-11 mb-11'}>
              <Button
                variant={'primary-outline'}
                className={'w-100'}
                onClick={() => handleClose()}
              >
                Close
              </Button>
            </Col>
          </Row>
         </Container>
        </section>
      </ModalBody>
    </Modal>
  );
};

export default CommentModal;
